// extracted by mini-css-extract-plugin
export default {"wrap":"RouteLoadingFallback_wrap__XHJvY","pulse":"RouteLoadingFallback_pulse__bRBh4"};